import { render, staticRenderFns } from "./UpdateStaff.vue?vue&type=template&id=abbdb190&scoped=true"
import script from "./UpdateStaff.vue?vue&type=script&lang=js"
export * from "./UpdateStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbdb190",
  null
  
)

export default component.exports